import React from 'react'
import { TextareaAutosize } from '@material-ui/core'
import debounce from 'lodash.debounce'
import dayjs from 'dayjs'
import { usePaperExpand } from './util'

const STORAGE_KEY = 'swroller-notepad-text'

const Notepad = ({ isDarkMode, titleClass }) => {
  const textRef = React.useRef(null)
  const [ localStorageData, setLocalStorageData ] = React.useState('')
  const [ lastChanged, setLastChanged ] = React.useState(null)
  const [ lastSaved, setLastSaved ] = React.useState(dayjs())
  const { isOpen, expander } = usePaperExpand('notepad')

  React.useEffect(() => {
    const text = textRef.current
    const savedData = window.localStorage.getItem(STORAGE_KEY)
    if (savedData) {
      setLocalStorageData(savedData)
    }
    return () => {
      if (text) window.localStorage.setItem(STORAGE_KEY, text.value)
    }
  }, [])

  const title = (
    <div className={titleClass} css={`display: flex; margin-bottom: ${!isOpen && '0'};`}>
      {expander}
      Notepad
    </div>
  )

  const changeHandler = React.useCallback(
    debounce(() => {
      window.localStorage.setItem(STORAGE_KEY, textRef.current.value)
      setLastSaved(dayjs())
    },
    2000
  ), [])

  if (!isOpen) return title

  return (
    <>
      <div css={`display: flex; justify-content: space-between;`}>
        {title}
        <div css={`display: flex; align-items: center; margin-bottom: 16px; font-size: 11px; text-align: right; line-height: 1.1;`}>
          Notes are automatically saved
        </div>
      </div>
      <div css={`position: relative;`}>
        <TextareaAutosize
          ref={textRef}
          defaultValue={localStorageData}
          onChange={() => {
            setLastChanged(dayjs())
            changeHandler()
          }}
          rowsMin={8}
          css={`
            width: 100%;
            font-family: 'Roboto';
            font-size: 16px;
            background-color: transparent;
            border-radius: 4px;
            border-color: ${isDarkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'};
            padding: 8px;
            margin: 8px 0;

            ${isDarkMode ? 'color: white;' : ''}
          `}
        />
        <div css={`position: absolute; text-align: right; bottom: -8px; right: 0; opacity: 0.6; font-size: 12px;`}>
          {(lastChanged && lastSaved) ?
            (lastSaved.isAfter(lastChanged) ? 'Saved' : 'New changes')
            :
            'Saved'
          }
        </div>
      </div>
    </>
  )
}

export default Notepad
